import { MDBBtn, MDBIcon, MDBModalFooter } from "mdb-react-ui-kit";
import React from "react";
import { useTranslation } from "react-i18next";

function MultiSaveLimitAlert(props) {
  const { t, i18n } = useTranslation();
  return (
    <>
      <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
        <MDBIcon
          fas
          icon="exclamation-triangle"
          className="me-3 fs-5 mt-1"
          color="warning"
        />
        <div dangerouslySetInnerHTML={{ __html: props.saveWarningMessage }} />
      </div>
      <MDBModalFooter>
        <MDBBtn color="secondary" onClick={(e) => props.onClose()}>
          {t("cancel")}
        </MDBBtn>
        <MDBBtn
          onClick={(e) => {
            e.preventDefault();
            props.handleClick(1);
          }}
        >
          {t("ok")}
        </MDBBtn>
      </MDBModalFooter>
    </>
  );
}

export default MultiSaveLimitAlert;
